$('#gateway-modal, #site-header-search').on('shown.bs.modal', function () {
    $('.modal-backdrop').css('z-index', 980);
});

//Adjust Header heights
var headerHeight = $("header.site-header").outerHeight();
function adjustHeaderHeight() {
    var AlertBArsCumilativeHeights = $(".alert-bar").toArray().reduce((prev, curr) => { return $(curr).height() + prev }, 0)
    $("#root > .bs4-nav > .sticky-wrapper").height(headerHeight + AlertBArsCumilativeHeights);
    $("body > .bs4-nav:first").height(headerHeight + AlertBArsCumilativeHeights);
}
adjustHeaderHeight()